import { type DragControls, Reorder, useDragControls } from 'motion/react';
import type React from 'react';
import { useDraggableListContext } from '../context/DraggableListContext';

export interface DraggableListItemProps {
  renderItem: (dragControls: DragControls) => React.ReactNode;
  value: any;
  style?: React.CSSProperties;
}

const DraggableListItem = ({ renderItem, style, value }: DraggableListItemProps) => {
  const dragControls = useDragControls();
  const { onDrag, onDragStart, onDragEnd } = useDraggableListContext();

  const handleDragStart = () => {
    onDragStart?.(dragControls);
  };

  return (
    <Reorder.Item
      value={value}
      dragListener={false}
      dragControls={dragControls}
      onDrag={onDrag}
      onDragStart={handleDragStart}
      onDragEnd={onDragEnd}
      whileDrag={{
        scale: 1.02,
        zIndex: 1000,
        rotate: 2,
        boxShadow: '0 10px 25px rgba(0, 0, 0, 0.1)',
      }}
      transition={{
        type: 'spring',
        stiffness: 300,
        damping: 30,
      }}
      as='div'
      style={{ zIndex: 1, position: 'relative', ...style }}
      data-draggable-item
    >
      {renderItem(dragControls)}
    </Reorder.Item>
  );
};

export default DraggableListItem;
